export const REQUEST_STORY = 'STORIES/REQUEST_STORY';
export const RECEIVE_STORY = 'STORIES/RECEIVE_STORY';
export const UNSELECT = 'STORES/UNSELECT';
export const REQUEST_STORIES = 'STORES/REQUEST_STORIES';
export const RECEIVE_STORIES = 'STORES/RECEIVE_STORIES';

export const REQUEST_SAVING = 'STORES/REQUEST_SAVING';
export const RECEIVE_SAVING = 'STORIES/RECEIVE_SAVING';

export const UPDATE_SETTINGS = 'STORIES/UPDATE_SETTINGS';
export const UPDATE_CONTENT = 'STORIES/UPDATE_CONTENT';
export const REQUEST_CONTENT_SAVING = 'STORES/REQUEST_CONTENT_SAVING';
export const RECEIVE_CONTENT_SAVING = 'STORIES/RECEIVE_CONTENT_SAVING';

export const REQUEST_PUBLISHING = 'STORIES/REQUEST_PUBLISHING';
export const RECEIVE_PUBLISHING = 'STORIES/RECEIVE_PUBLISHING';

export const REQUEST_TRIGGER_PUSH = 'STORIES/REQUEST_TRIGGER_PUSH';
export const RECEIVE_TRIGGER_PUSH = 'STORIES/RECEIVE_TRIGGER_PUSH';

export const CREATE_DRAFT = 'STORIES/CREATE_DRAFT';

export const REQUEST_DELETING = 'STORIES/REQUEST_DELETING';
export const RECEIVE_DELETING = 'STORIES/RECEIVE_DELETING';